import { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";
import { useCart } from "../CartContext";

const Category = ({ talk }) => {
  // const [numb, setNumb] = useState(0);
  const [sort, setSort] = useState("");
  const [closeFilter, setCloseFilter] = useState(false);
  // const [openFilter, setOpenFilter] = useState(false);
  const [productData, setProductData] = useState([]);
  const { cart, addToCart, decreaseQuantity } = useCart();

  useEffect(() => {
    fetch("products.json")
      .then((res) => res.json())
      .then((data) => setProductData(data));
  }, []);

  function reset() {
    setPriceRange1(15);
    setPriceRange2(800);
    setSort("");
  }
  const [pricerange1, setPriceRange1] = useState(15);
  const [pricerange2, setPriceRange2] = useState(800);
  const minGap = 0;

  function minInput(e) {
    let gap = pricerange2 - e;
    if (gap <= minGap) {
      setPriceRange1(() => pricerange2 - minGap);
    }
  }
  function maxInput(e) {
    let gap = e - pricerange1;
    if (gap <= minGap) {
      setPriceRange2(() => pricerange1 - minGap);
    }
  }

  function setOpenFilter() {
    return false;
  }

  if (sort === "high") {
    productData = [...productData].sort((a, b) => {
      return b.price - a.price;
    });
  } else if (sort === "low") {
    productData = [...productData].sort((a, b) => {
      return a.price - b.price;
    });
  }
  return (
    <div className="relative flex flex-row-reverse items-center lg:items-start">
      <div
        className={`fixed py-[30px] h-auto lg:relative top-0 right-0 bottom-0 w-[100%] lg:w-[25%] z-30 transition-all ease-in-out duration-700 ${
          !closeFilter
            ? "translate-x-[600px] lg:translate-x-[0px]"
            : "translate-x-0"
        }`}
      >
        <div className="absolute top-0 right-0 bottom-0 h-auto bg-[#3f3f3f6b] lg:bg-[#3f3f3f00] w-[100%] backdrop-blur-[20px] lg:backdrop-blur-[0px]"></div>
        <div className="absolute lg:relative overflow-y-scroll lg:overflow-y-hidden top-0 right-0 bottom-0 bg-white h-auto w-[90%] lg:w-[100%] px-[30px] py-[30px] lg:px-[30px] lg:py-[0px] z-50">
          <i
            className="fa-solid fa-x block lg:hidden relative left-[90%]"
            onClick={() => setCloseFilter(false)}
          ></i>

          <div className="flex flex-col items-center gap-8">
            <div className="w-[100%] px-[50px] flex flex-col items-center justify-start lg:relative pt-[100px]">
              <div className="flex justify-between mt-[-70px] lg:mt-[30px] mb-[30px] w-[100%]">
                <h3 className="font-[700] text-gray-500 ">Price($)</h3>
                <button
                  onClick={reset}
                  className="bg-amber-500 hover:bg-black hover:text-white py-[2px] px-[15px] font-[600] rounded-[5px] transition-all ease-in-out duration-300"
                >
                  Reset
                </button>
              </div>
              <div className="w-[100%] relative h-[5px] bg-gray-500 rounded-[90px]">
                <div
                  className="h-[100%] absolute bg-amber-500"
                  style={{
                    left: `${(pricerange1 / 900) * 100}%`,
                    width: `${((pricerange2 - pricerange1) / 900) * 100}%`,
                  }}
                ></div>
                <input
                  type="range"
                  name=""
                  id="range"
                  min={0}
                  max={900}
                  value={pricerange1}
                  onInput={(e) => {
                    setPriceRange1(e.target.value);
                    minInput(e.target.value);
                  }}
                />
                <input
                  type="range"
                  name=""
                  id="range"
                  min={0}
                  max={900}
                  value={pricerange2}
                  onInput={(e) => {
                    setPriceRange2(e.target.value);
                    maxInput(e.target.value);
                  }}
                />
              </div>
              <div className="flex justify-center gap-2 my-[30px]">
                <div className="w-[50%] flex">
                  <span className="relative left-[15%]">$</span>
                  <input
                    type="text"
                    value={pricerange1}
                    onChange={(e) => {
                      e.target.value < pricerange2 || e.target.value < 0
                        ? setPriceRange1(e.target.value)
                        : setPriceRange1(pricerange1);
                    }}
                    className="border-[1px] border-black rounded-[3px] w-[100px] pl-[20px]"
                  />
                </div>
                <div className="relative left-[1%]">-</div>
                <div className="w-[50%] flex">
                  <span className="relative left-[15%]">$</span>
                  <input
                    type="text"
                    value={pricerange2}
                    onChange={(e) => {
                      e.target.value > 900 || e.target.value <= 0
                        ? setPriceRange2(pricerange2)
                        : setPriceRange2(e.target.value);
                    }}
                    className="border-[1px] border-black rounded-[3px] w-[100px] pl-[20px]"
                  />
                </div>
              </div>
            </div>
            <select
              className="border-[1px] rounded-[5px] w-[250px] h-[30px]"
              onChange={(e) => setSort(e.target.value)}
            >
              <option value="">Default</option>
              <option value="high">Most Expensive</option>
              <option value="low">Most Cheapest</option>
            </select>
          </div>

          <ul className="grid grid-cols-1 gap-[30px] my-[15px] lg:my-[50px] mx-[10px] w-[90%]">
            <h3 className="font-[600] text-[22px]">Best Selling</h3>
            {productData.slice(0, 5).map((prod) => (
              <li className="relative block" key={prod.id}>
                <NavLink
                  to={`/shop/${prod.id}`}
                  className="flex items-center gap-4"
                >
                  <img
                    src={prod.image}
                    alt=""
                    className="h-[70px] border-[1px] border-[#9b9b9b96] rounded-[10px] py-[5px] px-[5px]"
                  />
                  <div>
                    <h3 className="text-[15px] font-[600]">{prod.name}</h3>
                    <p className="text-[12px] font-[700] text-gray-500">
                      ${prod.price}.00
                    </p>
                  </div>
                </NavLink>
              </li>
            ))}
          </ul>
        </div>
      </div>

      <div className="w-[99%] lg:w-[75%] mt-[60px]">
        <button
          className="ml-[10px] block lg:hidden bg-amber-500 py-[5px] px-[10px] text-white rounded-[5px] text-[13px]"
          onClick={() => setOpenFilter(setCloseFilter(true))}
        >
          <i className="fa-solid fa-bars"></i> FILTER
        </button>
        <ul className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-[30px] my-[15px] lg:my-[50px] mx-[10px]">
          {productData
            .filter((prod) => prod.category === talk)
            .map((prod) => {
              const cartItem = cart.find((item) => item.id === prod.id);
              return prod.price >= pricerange1 && prod.price <= pricerange2 ? (
                <li
                  className={`border-[1px] border-slate-300 text-center rounded-[5px] relative block`}
                  key={prod.id}
                >
                  <NavLink to={`/shop/${prod.id}`}>
                    <img
                      src={prod.image}
                      alt=""
                      className="hover:scale-110 transition-all ease-in-out duration-500"
                    />
                  </NavLink>
                  <i class="fa-regular fa-heart absolute top-[5%] left-[80%] bg-gray-200 p-[9px] rounded-full text-[13px] hover:bg-amber-500 hover:text-white cursor-pointer"></i>
                  <h3 className="text-[22px] font-[600]">{prod.name}</h3>
                  <p className="text-[10px] text-gray-600 font-[600] uppercase">
                    {prod.category}
                  </p>
                  {cartItem && cartItem.quantity > 0 ? (
                    <div className="border-t-[1px] border-slate-300 mt-[25px] flex justify-between items-center px-[15px] py-[10px] text-center">
                      <span className="font-[600] text-[14px] text-gray-600">
                        ${prod.price.toFixed(2)}
                      </span>
                      <div className="w-[50%] flex items-center justify-end">
                        <button
                          className={`${
                            cartItem.quantity <= 1
                              ? "bg-gray-500"
                              : "bg-amber-500"
                          } text-white p-[5px] w-[40px]`}
                          onClick={() => decreaseQuantity(prod.id)}
                        >
                          -
                        </button>
                        <span className="w-[40px]">{cartItem.quantity}</span>
                        <button
                          className="bg-amber-500 text-white p-[5px] w-[40px]"
                          onClick={() => addToCart(prod)}
                        >
                          +
                        </button>
                      </div>
                    </div>
                  ) : (
                    <div className="border-t-[1px] border-slate-300 mt-[25px] flex justify-between items-center px-[15px] py-[10px] text-center">
                      <p className="font-[600] text-slate-600">
                        ${prod.price}.00
                      </p>
                      <span className="relative left-[5%] text-gray-300">
                        |
                      </span>
                      <button
                        onClick={() => addToCart(prod)}
                        className="text-[14px] font-[600] text-slate-600 hover:text-amber-500"
                      >
                        ADD TO CART
                      </button>
                    </div>
                  )}
                </li>
              ) : (
                ""
              );
            })}
        </ul>
      </div>
    </div>
  );
};

export default Category;
